{
  "name": "@kubb/ui",
  "version": "3.16.1",
  "description": "User interface components and web dashboard for Kubb, providing a visual interface for managing and monitoring code generation.",
  "keywords": [
    "ui",
    "dashboard",
    "web-interface",
    "react",
    "tailwindcss",
    "hono",
    "typescript",
    "kubb"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/kubb-labs/kubb.git",
    "directory": "packages/ui"
  },
  "license": "MIT",
  "author": "stijnvanhulle",
  "sideEffects": false,
  "type": "module",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs",
      "default": "./dist/index.cjs"
    },
    "./package.json": "./package.json",
    "./*": "./*"
  },
  "main": "dist/index.cjs",
  "module": "dist/index.js",
  "types": "./dist/index.d.ts",
  "typesVersions": {
    "*": {}
  },
  "files": [
    "src",
    "static",
    "dist",
    "!/**/**.test.**",
    "!/**/__tests__/**"
  ],
  "scripts": {
    "build": "tsup && vite build",
    "clean": "npx rimraf ./dist",
    "lint": "bun biome lint .",
    "lint:fix": "bun biome lint--fix --unsafe .",
    "preview": "vite preview",
    "release": "pnpm publish --no-git-check",
    "release:canary": "bash ../../.github/canary.sh && node ../../scripts/build.js canary && pnpm publish --no-git-check",
    "start": "vite & tsup --watch",
    "test": "vitest --passWithNoTests",
    "typecheck": "tsc -p ./tsconfig.json --noEmit --emitDeclarationOnly false"
  },
  "dependencies": {
    "@hono/node-server": "^1.16.0",
    "@hono/zod-openapi": "0.19.2",
    "hono": "^4.8.5",
    "zod": "^3.25.76"
  },
  "devDependencies": {
    "@heroui/react": "^2.8.1",
    "@heroui/theme": "^2.4.19",
    "@heroui/use-theme": "^2.1.10",
    "@kubb/config-ts": "workspace:*",
    "@kubb/config-tsup": "workspace:*",
    "@react-aria/visually-hidden": "3.8.20",
    "@react-types/shared": "3.28.0",
    "@tanstack/react-query": "^5.83.0",
    "@types/node": "catalog:",
    "@types/react": "catalog:",
    "@types/react-dom": "catalog:",
    "@vitejs/plugin-react": "^4.6.0",
    "autoprefixer": "10.4.19",
    "clsx": "2.1.1",
    "framer-motion": "11.15.0",
    "postcss": "8.4.38",
    "react": "catalog:",
    "react-dom": "catalog:",
    "react-router-dom": "^7.6.3",
    "tailwind-variants": "0.3.0",
    "tailwindcss": "3.4.16",
    "tsup": "catalog:",
    "typescript": "catalog:",
    "vite": "^6.3.5",
    "vite-tsconfig-paths": "^5.1.4"
  },
  "engines": {
    "node": ">=20"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  }
}
